// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/AblHero';
import Intro from '../components/AblIntro';
import Stats from '../components/AblCEO';
import Footer from '../components/Footer';

function AkijBakers() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default AkijBakers;
